import styled from '@emotion/styled';
import React from 'react';
import PropTypes from 'prop-types';
import { StyledH2Light } from './_shared/styled-headings';
import { StyledSection } from './_shared/styled-section';
import { StyledPLight } from './_shared/styled-headings';
import { StyledTagLight } from './_shared/styled-headings';
import { flexCenter } from './_shared/styled-mixins';

const StyledBlock = styled(StyledSection)`
  background-color: #fff;
  width: 100%;
  display: flex;
  ${flexCenter};
  flex-direction: column;
  padding: 3rem 0;

  color: var(--lightbg-content-color);
  text-align: center;
  font-size: 0.8rem;
`;

const StyledContent = styled.div`
  width: 100%;
  padding: 4rem calc((var(--space) / 2));
  text-align: center;
  font-size: 0.8rem;
`;

const How = ({ data }) => {
  const { summary } = data;

  return (
    <React.Fragment>
      <StyledBlock>
        <StyledContent>
          <StyledTagLight>HOW DOES IT WORK?</StyledTagLight>
          <StyledH2Light>Simplify your job search</StyledH2Light>
          <StyledPLight dangerouslySetInnerHTML={{ __html: summary }} />
        </StyledContent>
      </StyledBlock>
    </React.Fragment>
  );
};

How.propTypes = {
  data: PropTypes.object.isRequired,
};

export default How;
